import { useAuth0 } from "@auth0/auth0-react";

import App from "./App";

import "./ExcalidrawApp.scss";

export default function ExcalidrawApp() {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();

  if (isAuthenticated) {
    return <App />;
  }

  return (
    <div className="auth-container">
      <div className="auth-content">
        <img className="auth-bg" src="og-image-3.png" alt="bg" />
        {error && <p className="auth-error">{error.message}</p>}
        {isLoading ? (
          <div className="auth-loading">
            <div className="auth-loading-icon" />
            <h3 className="auth-loading-text">Please wait...</h3>
          </div>
        ) : (
          <button
            className="auth-continue-button"
            onClick={() => loginWithRedirect()}
          >
            <span>Continue with Auth0</span>
          </button>
        )}
      </div>
    </div>
  );
}
